import type React from 'react';

function WikipediaIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 594.79 443.57"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Wikipedia Icon</title>

      <g id="Capa_1" data-name="Capa 1">
        <path
          d="M594.78,15.29c0,3.63-2.94,6.57-6.57,6.57h-18.38c-6.7,0-12.74,4.05-15.26,10.26l-167.7,411.46-84.46-189.6-90.37,189.6L39.09,31.95c-2.57-6.12-8.56-10.1-15.2-10.1H6.57c-3.63,0-6.57-2.94-6.57-6.57V0H149.43l-.42,15.46c-.1,3.56-3.01,6.39-6.57,6.39h-25.01c-9.31,0-15.69,9.38-12.26,18.03l121.42,307.17,61.41-133.1L210.41,31.88c-2.59-6.08-8.56-10.02-15.16-10.02h-12.07c-3.63,0-6.57-2.94-6.57-6.57V0h112.22V15.29c0,3.63-2.94,6.57-6.57,6.57-9.47,0-15.85,9.69-12.12,18.39l45.86,106.83,46.82-106.73c3.82-8.71-2.56-18.48-12.08-18.48h-17.55c-3.63,0-6.57-2.94-6.57-6.57V0h117.54V15.29c0,3.63-2.94,6.57-6.57,6.57h-19.56c-6.4,0-12.22,3.71-14.93,9.5l-72.34,154.7,67.54,158.72L516.5,39.75c3.29-8.63-3.08-17.88-12.32-17.88h-29.22c-3.63,0-6.57-2.94-6.57-6.57V0h126.4V15.29h0Z"
          fill="inherit"
        />
      </g>
    </svg>
  );
}

export default WikipediaIcon;
